import React from 'react';
import { Zap, Heart, Wind, Shield, Battery, TrendingUp } from 'lucide-react';
import '../styles/BenefitsSection.css';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Zap size={32} />,
      title: 'Natural Energy',
      description: 'Enhance stamina and vitality without jitters or crashes, supporting sustained energy throughout your day.'
    },
    {
      icon: <Wind size={32} />,
      title: 'Oxygen Utilization',
      description: 'Improve oxygen uptake and cellular respiration, optimizing physical performance and endurance.'
    },
    {
      icon: <Shield size={32} />,
      title: 'Immune Support',
      description: 'Strengthen your body\'s natural defenses with bioactive compounds that support immune system function.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Adaptogenic Balance',
      description: 'Support your body\'s response to stress while promoting overall homeostasis and wellbeing.'
    },
    {
      icon: <Battery size={32} />,
      title: 'Anti-Fatigue',
      description: 'Combat physical and mental fatigue, supporting faster recovery and sustained performance.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Metabolic Vitality',
      description: 'Support healthy metabolic function and cellular energy production for optimal vitality.'
    }
  ];

  return (
    <section id="benefits" className="benefits-section section-padding">
      <div className="container">
        <div className="benefits-header">
          <h2 className="heading-1">
            Science-Backed <span className="accent-orange">Benefits</span>
          </h2>
          <p className="body-large benefits-intro">
            Cordyceps militaris offers a comprehensive range of wellness benefits, validated by both traditional use and modern research.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card hover-lift">
              <div className="benefit-icon accent-orange">
                {benefit.icon}
              </div>
              <h3 className="heading-3">{benefit.title}</h3>
              <p className="body-regular">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="benefits-image-wrapper">
          <img 
            src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438" 
            alt="Athletic performance and strength training"
            className="benefits-image"
          />
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;